module.exports = __webpack_public_path__ + "static/media/pots_pans_salt_pepper.1707cdac.svg";